import { Box } from '@mui/material';
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';
import { siopColors } from '../../config/theme';
import { PASSWORD_RULES } from '../../validators/auth.validators';

/**
 * The password policy as a live checklist: each rule ticks green as the typed
 * password meets it.
 *
 * Moved out of ForgotPassword.jsx (TASK-2026-10-12-002) so Change Password and
 * Add User show the same list from the same PASSWORD_RULES — one checklist,
 * not three copies drifting apart.
 */
const PasswordPolicyChecklist = ({ password }) => (
  <Box component="ul" aria-label="Password requirements" sx={{ listStyle: 'none', p: 0, m: 0 }}>
    {PASSWORD_RULES.map((rule) => {
      const met = rule.test(password);
      return (
        <Box
          component="li"
          key={rule.id}
          data-met={met}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            fontSize: 12,
            color: met ? siopColors.green : siopColors.grey,
            mb: 0.25,
          }}
        >
          {met ? (
            <CheckCircle sx={{ fontSize: 14 }} />
          ) : (
            <RadioButtonUnchecked sx={{ fontSize: 14 }} />
          )}
          {rule.label}
        </Box>
      );
    })}
  </Box>
);

export default PasswordPolicyChecklist;
